export const FACET_KEY_TYPES = 'layouts.type';
export const FACET_KEY_MEDIUMS = 'extra_mediums';
export const FACET_KEY_COLORS = 'extra_colors_secondary_lv1';
export const FACET_KEY_STYLES_LV1 = 'extra_styles_lv1';
export const FACET_KEY_ARTISTS = 'artist_name';
export const FACET_KEY_PIECES = 'layouts.pieces';
export const FACET_KEY_SHAPES = 'layouts.shape';
export const FACET_KEY_ROOMS = 'layouts.room_previews.room_type';
export const FACET_KEY_NAMES = 'layouts.name';
export const FACET_KEY_TAGS = 'tags';
